

<template>
  
  <b-card border-variant="light">
    
    <h5 class="my-2">Cuestionario corto para la evaluación de la Vejiga Hiperactiva.</h5>

    <div>
      Por favor, anote el NÚMERO aplicable a su caso en las casillas indicadas 
      por las flechas, teniendo en cuenta lo siguiente:
      <div>EN ABSOLUTO = 0 UN POCO = 1 BASTANTE = 2 MUCHO = 3</div>
    </div>

    <hr>

    <b-row class="my-2">
      <b-col>

        <b-row 
        >
          <b-col >
            <h6 class="text-center">Sintomas</h6>
          </b-col>
          <b-col>
            <h6 class="text-center">Molestia</h6>
          </b-col>
        </b-row>

        <hr>

        <b-row align-v="center">
          <b-col class="col-6">

            <b-row align-v="center">
              <b-col class="col-3">
                <b-form-select 
                  v-model="preguntas.pregunta1.sintomas" 
                  :options="optionsRange"
                />
              </b-col>
              <b-col >
                ¿Le resulta difícil retener la orina cuando 
                siente la necesidad urgente de orinar?
              </b-col>
            </b-row>
            
          </b-col>

          <b-col>
            <b-row align-v="center">
              <b-col class="col-3">
                <b-form-select 
                  v-model="preguntas.pregunta1.molestia" 
                  :options="optionsRange"
                />
              </b-col>
              <b-col >
                ¿En que medida le molesta?
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <hr>

        <b-row align-v="center">
          <b-col class="col-6">

            <b-row align-v="center">
              <b-col class="col-3">
                <b-form-select 
                  v-model="preguntas.pregunta2.sintomas" 
                  :options="optionsRange"
                />
              </b-col>
              <b-col >
                ¿Necesita ir al lavabo con demasiada 
                frecuencia durante el día?
              </b-col>
            </b-row>
            
          </b-col>

          <b-col>
            <b-row align-v="center">
              <b-col class="col-3">
                <b-form-select 
                  v-model="preguntas.pregunta2.molestia" 
                  :options="optionsRange"
                />
              </b-col>
              <b-col >
                ¿En que medida le molesta?
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <hr>

        <b-row align-v="center">
          <b-col class="col-6">

            <b-row align-v="center">
              <b-col class="col-3">
                <b-form-select 
                  v-model="preguntas.pregunta3.sintomas" 
                  :options="optionsRange"
                />
              </b-col>
              <b-col >
                ¿Se despierta por la noche con la 
                necesidad urgente de orinar?
              </b-col>
            </b-row>
            
          </b-col>

          <b-col>
            <b-row align-v="center">
              <b-col class="col-3">
                <b-form-select 
                  v-model="preguntas.pregunta3.molestia" 
                  :options="optionsRange"
                />
              </b-col>
              <b-col >
                ¿En que medida le molesta?
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <hr>

        <b-row align-v="center">
          <b-col class="col-6">

            <b-row align-v="center">
              <b-col class="col-3">
                <b-form-select 
                  v-model="preguntas.pregunta4.sintomas" 
                  :options="optionsRange"
                />
              </b-col>
              <b-col >
                ¿Tiene pérdidas de orina?
              </b-col>
            </b-row>
            
          </b-col>

          <b-col>
            <b-row align-v="center">
              <b-col class="col-3">
                <b-form-select 
                  v-model="preguntas.pregunta4.molestia" 
                  :options="optionsRange"
                />
              </b-col>
              <b-col >
                ¿En que medida le molesta?
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <hr>

        <b-row align-v="center">
          <b-col class="col-6">

            <b-row class="my-1">
              <b-col>
                <b>Total puntaje de "Sintomas"</b>
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col>
                <b-progress 
                  :value="totalSintomas"
                  :max="12" 
                  striped
                  show-value
                  :variant="colorBarTotal( totalSintomas )"
                />
              </b-col>
              
            </b-row>

            <b-row align-v="center">
              <b-col class="col-3">
                <b-form-input 
                  :value="totalSintomas"
                  disabled
                />
              </b-col>
              <!-- <b-col >
                {{ getMessagePuntajes(totalSintomas) }}
              </b-col> -->
            </b-row>
            
          </b-col>

          <b-col>
            <b-row class="my-1">
              <b-col>
                <b>Total puntaje de "Molestias"</b>                
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col>
                <b-progress 
                  :value="totalMolestias"
                  :max="12" 
                  striped
                  show-value
                  :variant="colorBarTotal( totalMolestias )"
                />
              </b-col>
              
            </b-row>

            <b-row align-v="center">
              <b-col class="col-3">
                <b-form-input :value="totalMolestias" disabled/>
              </b-col>
              <b-col >
                {{ getMessagePuntajes(totalMolestias) }}
              </b-col>
            </b-row>
          </b-col>
        </b-row>

      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  
  name: "CACV",

  data() {
    return {

      preguntas:{
        pregunta1:{
          sintomas:0,
          molestia:0,
        },

        pregunta2:{
          sintomas:0,
          molestia:0,
        },

        pregunta3:{
          sintomas:0,
          molestia:0,
        },

        pregunta4:{
          sintomas:0,
          molestia:0,
        },

        totalSintomas:this.totalSintomas,
        totalMolestias:this.totalMolestias,
      },

      optionsRange: [
        { value:0, text: '0' }, 
        { value:1, text: '1' }, 
        { value:2, text: '2' }, 
        { value:3, text: '3' },
      ],
    }
  },


  methods: {
    getMessagePuntajes( scoreAny ){
      const score = parseInt(scoreAny, 10);
      return score < 1 
        ? 'No tiene molestias debido a problemas urinarios'
        : score <= 3
          ? 'Sus sintomas le molestan ligeramente'
          : score <= 6
            ? 'Sus sintomas le molestan bastante'
            : score <= 9
              ? 'Sus sintomas son una molestia importante para usted'
              : 'Sus sintomas son un problema grave para usted';
    },

    colorBarTotal(score) {
      return(
        score < 4 
          ? 'success' 
          : score < 7
            ? 'info'
            : score < 10
              ? 'warning'
              : 'danger'
      );
        
    }
  },


  computed: {
    totalSintomas() {
      return (
        this.preguntas.pregunta1.sintomas
        + this.preguntas.pregunta2.sintomas 
        + this.preguntas.pregunta3.sintomas 
        + this.preguntas.pregunta4.sintomas
      );
    },

    totalMolestias() {
      return (
        this.preguntas.pregunta1.molestia 
        + this.preguntas.pregunta2.molestia 
        + this.preguntas.pregunta3.molestia
        + this.preguntas.pregunta4.molestia
      );
    },

  },

}
</script>
